module.exports = __webpack_public_path__ + "img/success.d665818a.png";